// client/src/modules/billing/index.ts
import type { ModuleManifest } from '../types';
import { navItems } from './nav';
import { routes } from './routes';

/**
 * Billing module manifest (P4)
 *
 * Billing & Collections - AR coordination, collections workflow.
 * Fully migrated to module registry with lazy-loaded routes.
 */
export const billingModule: ModuleManifest = {
  id: 'P4',
  name: 'Finance',
  shortName: 'Finance',
  description: 'Invoice coordination, AR management, and collections workflow',
  icon: '💰',
  status: 'live',
  urlPrefix: '/billing',
  routes,
  navItems,
};

export default billingModule;
